
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ideas/IdeaBoardPage/IdeaBoardPage",
      function () {
        return require("private-next-pages/ideas/IdeaBoardPage/IdeaBoardPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ideas/IdeaBoardPage/IdeaBoardPage"])
      });
    }
  